export const mockFormConfig = {
  pageTitle: "Add Integration",
  provider: "AWS",
  fields: [
    {
      id: "name",
      type: "text_input",
      label: "Integration Name",
      required: true,
      placeholder: "Enter integration name",
    },
    {
      id: "description",
      type: "text_area",
      label: "Integration Description (optional)",
      rows: 6,
      placeholder: "Enter integration description",
    },
    {
      id: "account_id",
      type: "text_input",
      label: "AWS Account ID",
      required: true,
      placeholder: "Account ID",
    },
    {
      id: "role_arn",
      type: "text_input",
      label: "Role ARN",
      required: true,
      placeholder: "Enter Role ARN",
      visibleWhen: "cftDownloaded",
    },
    {
      id: "external_id",
      type: "password_input",
      label: "External ID",
      required: true,
      placeholder: "Enter External ID",
      visibleWhen: "cftDownloaded",
    },
  ],
  regions: [
    {
      label: "US East (N. Virginia): us-east-1",
      value: "us-east-1",
      isChecked: true,
    },
    {
      label: "US East (Ohio): us-east-2",
      value: "us-east-2",
      isChecked: true,
    },
    {
      label: "US West (N. California): us-west-1",
      value: "us-west-1",
      isChecked: true,
    },
    {
      label: "US West (Oregon): us-west-2",
      value: "us-west-2",
      isChecked: true,
    },
    {
      label: "Canada (Central): ca-central-1",
      value: "ca-central-1",
      isChecked: true,
    },
    {
      label: "Canada West (Calgary): ca-west-1",
      value: "ca-west-1",
      isChecked: true,
    },
    {
      label: "Mexico (Central): mx-central-1",
      value: "mx-central-1",
      isChecked: true,
    },
    {
      label: "Europe (Frankfurt): eu-central-1",
      value: "eu-central-1",
      isChecked: true,
    },
    {
      label: "Europe (Ireland): eu-west-1",
      value: "eu-west-1",
      isChecked: true,
    },
    {
      label: "Europe (London): eu-west-2",
      value: "eu-west-2",
      isChecked: true,
    },
    {
      label: "Europe (Paris): eu-west-3",
      value: "eu-west-3",
      isChecked: true,
    },
    {
      label: "Europe (Stockholm): eu-north-1",
      value: "eu-north-1",
      isChecked: true,
    },
    {
      label: "Europe (Milan): eu-south-1",
      value: "eu-south-1",
      isChecked: true,
    },
    {
      label: "Europe (Spain): eu-south-2",
      value: "eu-south-2",
      isChecked: true,
    },
    {
      label: "Europe (Zurich): eu-central-2",
      value: "eu-central-2",
      isChecked: true,
    },
    {
      label: "EU (Germany): eusc-de-east-1",
      value: "eusc-de-east-1",
      isChecked: true,
    },
    {
      label: "Israel (Tel Aviv): il-central-1",
      value: "il-central-1",
      isChecked: true,
    },
    {
      label: "Middle East (Bahrain): me-south-1",
      value: "me-south-1",
      isChecked: true,
    },
    {
      label: "Middle East (UAE): me-central-1",
      value: "me-central-1",
      isChecked: true,
    },
    {
      label: "Africa (Cape Town): af-south-1",
      value: "af-south-1",
      isChecked: true,
    },
    {
      label: "Asia Pacific (Tokyo): ap-northeast-1",
      value: "ap-northeast-1",
      isChecked: true,
    },
    {
      label: "Asia Pacific (Seoul): ap-northeast-2",
      value: "ap-northeast-2",
      isChecked: true,
    },
    {
      label: "Asia Pacific (Osaka): ap-northeast-3",
      value: "ap-northeast-3",
      isChecked: true,
    },
    {
      label: "Asia Pacific (Singapore): ap-southeast-1",
      value: "ap-southeast-1",
      isChecked: true,
    },
    {
      label: "Asia Pacific (Sydney): ap-southeast-2",
      value: "ap-southeast-2",
      isChecked: true,
    },
    {
      label: "Asia Pacific (Mumbai): ap-south-1",
      value: "ap-south-1",
      isChecked: true,
    },
    {
      label: "Asia Pacific (Hyderabad): ap-south-2",
      value: "ap-south-2",
      isChecked: true,
    },
    {
      label: "Asia Pacific (Jakarta): ap-southeast-3",
      value: "ap-southeast-3",
      isChecked: true,
    },
    {
      label: "Asia Pacific (Melbourne): ap-southeast-4",
      value: "ap-southeast-4",
      isChecked: true,
    },
    {
      label: "Asia Pacific (Malaysia): ap-southeast-5",
      value: "ap-southeast-5",
      isChecked: true,
    },
    {
      label: "Asia Pacific (Thailand): ap-southeast-7",
      value: "ap-southeast-7",
      isChecked: true,
    },
    {
      label: "South America (São Paulo): sa-east-1",
      value: "sa-east-1",
      isChecked: true,
    },
  ],
};
